// extracted by mini-css-extract-plugin
export default {"wrap":"PG-z","fullWidth":"QG-z","hideOnDesktop":"RG-z","content":"SG-z","hasOpenedNav":"TG-z","crumbsList":"UG-z","dropdownsWrap":"VG-z"};